import React from 'react';

const JumboLayoutSidebarContext = React.createContext({});

export default JumboLayoutSidebarContext;
